import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {Switch} from 'antd'
import Main from './Main'
import Additional from './Additional'
import Footer from './Footer'

import style from './style.sass'

@withRouter
@inject('store') @observer
class Form extends Component {
  changeHandler = (name, value) => {
    this.props.store.algo.single.change(name, value)
  }
  updateAlgo = () => {
    this.props.store.algo.single.update()
  }
  updateAndRun = () => {
    this.props.store.algo.updateAndRun()
  }
  toggleAssetType = () => {
    this.props.store.algo.single.toggleAssetType()
  }
  render() {
    const {algo, permissions} = this.props.store
    const {data} = algo.single
    return(
      <form styleName='form'>
        <div
          styleName='asset-type'
          className={!permissions.checkUpgrade('lab.fx.use') ? 'card' : 'card upgrade-ribbon'}
        >
          <span>Stocks</span>
          <Switch
            checked={data.has_coin}
            name='has_coin'
            onChange={() => permissions.wrap('lab.fx.use', this.toggleAssetType)}
            size='large'
          />
          <span>Crypto</span>
        </div>
        <div className='card'>
          <Main hasCoin={data.has_coin}/>
          {!this.props.additionalFields ?
            <a onClick={this.props.showAdditional} styleName='add-cover-trade'>
              Add Cover Trade
            </a>
            :
            <Additional hasCoin={data.has_coin}/>
          }
          <Footer
            changeHandler={this.changeHandler}
          />
        </div>
      </form>
    )
  }
}

export default Form
